module.exports = __webpack_public_path__ + "static/img/bg5.79a13aea.png";